//导入模块
import center from '../components/center';

// 导出
export default{
    path:'/center',
    component:center,
}



// WEBPACK FOOTER //
// ./src/router/center.js